import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { EsportsTeamListComponent } from "./esports-team-list/esports-team-list.component";

const routes: Routes = [
  {
    path: "esports-teams",
    component: EsportsTeamListComponent,
    canActivate: [AuthGuard],
  },
];

export const EsportsTeamsRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/esports-teams.routes.ts